window.lang2 = 
{
  "general": {
    "404": {
      "title": "404",
      "subtext": "oops! Page Note Found",
      "content": "Désolé, mais la page que vous recherchez n'a pas été trouvée. S'il vous plaît, assurez-vous d'avoir tapé l'url actuelle.",
      "link": "Aller à la page d'accueil"
    },
    "password_page": {
      "opening_soon": "Ouverture prochaine",
      "spread_the_word": "Passez le mot:",
      "login_form_heading": "Entrer le magasin en utilisant le mot de passe:",
      "login_form_password_label": "Mot de passe",
      "login_form_password_placeholder": "Votre mot de passe",
      "login_form_submit": "Entrer",
      "signup_form_heading": "Découvrez quand nous ouvrons:",
      "signup_form_email_label": "Email",
      "signup_form_email_placeholder": "Votre email",
      "signup_form_submit": "Soumettre",
      "signup_form_success": "Nous vous enverrons un e-mail avant d'ouvrir!",
      "admin_link_html": "Êtes-vous le propriétaire du magasin? <a href=\"\/admin\" class=\"text-link\">Connectez-vous ici<\/a>",
      "password_link": "Entrer en utilisant le mot de passe",
      "powered_by_shopify_html": "Cette boutique sera propulsée par {{ shopify }}",
      "close": "Fermer (Esc)"
    }
  },
  "homepage": {
    "onboarding": {
      "product_title": "Nom de votre produit",
      "product_description": "Cette zone est utilisée pour décrire les détails de votre produit. Dites aux clients le look, la sensation et le style de votre produit. Ajouter des détails sur la couleur, les matériaux utilisés, le calibrage, et où il a été fait.",
      "collection_title": "Nom de votre collection",
      "blog_title": "Titre de votre annonce",
      "blog_excerpt": "Votre magasin n'a encore publié aucun billet de blog. Un blog peut être utilisé pour parler de lancements de nouveaux produits, de conseils ou d'autres nouvelles que vous souhaitez partager avec vos clients. Vous pouvez consulter Shopify blog de commerce électronique pour l'inspiration et des conseils pour votre propre magasin et blog.",
      "blog_author": "Author name",
      "no_content": "Cette section ne contient actuellement aucun contenu. Ajouter du contenu à cette section en utilisant la barre latérale.",
      "view_all": "Voir tout"
    }
  },
  "blog": {
    "article": {
      "view_all": "Voir tout",
      "all_topics": "Tous les sujets",
      "by_author": "par {{ author }}",
      "posted_in": "Publié dans",
      "read_more": "Lire la suite",
      "back_to_blog": "Retour à {{ title }}"
    },
    "list_blog": {
      "readmore": "CONTINUER LA LECTURE"
    },
    "comment_moderated": " Votre commentaire a bien été posté. Nous allons le publier dans un petit moment, comme notre blog est modéré.",
    "comment_successfully": "Votre commentaire a bien été posté! Je vous remercie!",
    "widget_blog_title": "Dernières nouvelles"
  },
  "page_cms": {
    "search": {
      "title": "Recherche de produits sur notre site"
    },
    "contact_success": "Merci de nous avoir contacté! Nous vous répondrons dès que possible.",
    "contact_button": "envoyer le message"
  },
  "customers": {
    "account": {
      "title": "Mon compte",
      "title_order_history": "Historique des commandes",
      "title_order": "Order",
      "title_date": "Date",
      "title_payment": "Statut de paiement",
      "title_fulfillment": "État d'accomplissement",
      "title_total": "Total",
      "note": "Vous n'avez pas encore passé de commande.",
      "title_account_details": "details du compte",
      "link": "Afficher les adresses"
    },
    "activate_account": {
      "title_activate_account": "Activer le compte",
      "subtext": "Créez votre mot de passe pour activer votre compte.",
      "password": "Mot de passe",
      "passconfirm": "Confirmation mot de passe",
      "activateaccount": "Activer le compte",
      "declineinvitation": "Décliner l'invitation"
    },
    "addresses": {
      "title": "Mon compte",
      "link_addnew": "Ajouter une nouvelle adresse",
      "link_return": "Retour aux détails du compte",
      "title_address": "ajouter une nouvelle adresse",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "company": "Compagnie",
      "address_1": "Adresse 1",
      "address_2": "Adresse 2",
      "city": "Ville",
      "country": "Pays",
      "provice": "Province",
      "zip_code": "Postal\/Code postal",
      "phone": "Téléphone",
      "default_address": "Définir comme adresse par défaut?",
      "cancel": "Annuler",
      "link_add_address": "Ajoutez l'adresse",
      "title_customer_address": "Carnet d'adresses client",
      "title_edit_address": "Modifier l'adresse",
      "link_update_address": "Adresse de mise à jour",
      "msg_note": "Voulez-vous vraiment supprimer cette adresse?"
    },
    "login": {
      "title": "Se connecter",
      "msg_success": "Nous vous avons envoyé un courriel avec un lien pour mettre à jour votre mot de passe.",
      "email_address": "Adresse e-mail",
      "password": "Mot de passe",
      "required_fields": "champs requis",
      "forgot_password": "Mot de passe oublié?",
      "link_sign_in": "Se connecter",
      "link_create_account": "Créer un compte",
      "title_reset_password": "réinitialisez votre mot de passe",
      "subtitle_reset_password": "Nous vous enverrons un courriel pour réinitialiser votre mot de passe.",
      "text_email": "Email",
      "link_submit": "Soumettre",
      "title_a_guest": "Continuez en tant qu'invité",
      "link_go": "Allons-y"
    },
    "order": {
      "title": "Mon compte",
      "return_account": "Retour aux détails du compte",
      "text_order": "Commande",
      "placed_on": "Placé sur",
      "order_cancelled": "Ordre annulé",
      "reason": "Raison",
      "title_product": "Produit",
      "title_sku": "SKU",
      "title_price": "Prix",
      "title_quantity": "Quantité",
      "title_total": "Total",
      "subtotal": "Sous-Total",
      "discount": "Remise",
      "title_billing_information": "détails de facturation",
      "payment_status": "Statut de paiement",
      "title_shipping_information": "Informations sur la livraison",
      "fulfillment_status": "État d'accomplissement"
    },
    "register": {
      "title": "Créer un compte",
      "first_name": "Prénom",
      "last_name": "Nom de famille",
      "email": "Votre adresse email",
      "password": "Votre mot de passe",
      "link_create_account": "Créer un compte",
      "or": "Or",
      "link_sign_in": "Sign In"
    },
    "reset": {
      "title": "Réinitialiser le mot de passe du compte",
      "sub_title": "Réinitialiser le mot de passe du compte",
      "password_confirmation": "Confirmation mot de passe",
      "reset_pass_value": "réinitialiser le mot de passe"
    }
  },
  "sections": {
    "map": {
      "get_directions": "Get directions",
      "address_error": "Error looking up that address",
      "address_no_results": "No results for that address",
      "address_query_limit_html": "You have exceeded the Google API usage limit. Consider upgrading to a <a href=\"https:\/\/developers.google.com\/maps\/premium\/usage-limits\">Premium Plan<\/a>.",
      "auth_error_html": "There was a problem authenticating your Google Maps account. Create and enable the <a href=\"https:\/\/developers.google.com\/maps\/documentation\/javascript\/get-api-key\">JavaScript API<\/a> and <a href=\"https:\/\/developers.google.com\/maps\/documentation\/geocoding\/get-api-key\">Geocoding API<\/a> permissions of your app."
    }
  },
  "page_cart": {
    "name": "Produit",
    "qty": "Qty",
    "price": "Prix",
    "remove": "Retirer",
    "comments": "Note Commentaires supplémentaires"
  },
  "page_wishlist": {
    "name": "Nom du produit",
    "image": "Image du produit",
    "price": "Prix unitaire",
    "remove": "Retirer",
    "add_cart": "Ajouter au panier"
  },
  "product": {
    "label_icon_new": "New",
    "regular_price": "Prix habituel",
    "sold_out": "Sold out",
    "unavailable": "Indisponible",
    "on_sale": "Vente",
    "quantity": "Quantité",
    "add_to_cart": "Ajouter au panier",
    "back_to_collection": "Back to {{ title }}",
    "detail": {
      "product_next": "Next Product",
      "product_prev": "Previous Product",
      "availability_label": "Disponibilité",
      "instock_product": "en stock",
      "outstock_product": "Rupture de stock",
      "manystock_product": "Many in stock",
      "add_wishlist": "Ajouter à la liste de souhaits",
      "add_cart": "Ajouter au panier",
      "pre_order": "Ajouter au panier",
      "unavailable": "Indisponible",
      "share_text": "Partager ce produit",
      "sellect_option": "Sélectionnez les options"
    },
    "quickview": "Quick View"
  },
  "collection": {
    "toolbar": {
      "label_view": "Voir comme",
      "label_softby": "Trier par:",
      "manual": "En vedette",
      "price_ascending": "Prix: bas à élevé",
      "price_descending": "Prix: du plus élevé au plus bas",
      "title_ascending": "A-Z",
      "title_descending": "Z-A",
      "created_ascending": "Du plus ancien au plus récent",
      "created_descending": "Du plus récent au plus ancien",
      "best_selling": "Meilleures ventes",
      "show": "Affichage"
    },
    "notice": "Il n'y a aucun produit dans cette collection."
  },
  "message": {
    "form_error": "Désolé, on dirait que quelque chose s'est mal passé. Veuillez corriger ce qui suit et soumettre à nouveau:",
    "success_cart": "Ajouté au panier succès.",
    "success_wishlist": "Ajouté au succès de la liste de souhaits."
  },
  "from_price": "from",
  "header": {
    "qty": "Quantité",
    "viewcart": "Voir le panier",
    "checkout": "Check-out",
    "total": "Total",
    "no_product": "Vous n'avez pas d'article dans votre panier.",
    "my_cart": "Mon panier",
    "custom_link_account": "Mon compte",
    "custom_link_wishlist": "Ma liste d'envies",
    "custom_link_checkout": "Check-out",
    "custom_link_logout": "Se déconnecter",
    "custom_link_login": "Se connecter",
    "custom_link_create_account": "Créer un compte",
    "search": "Rechercher un produit"
  },
  "footer": {
    "footer_newsletter_content": "Votre adresse email",
    "footer_newsletter_go": "souscrire"
  },
  "breadcrumb": {
    "home": "Accueil"
  }
}